import { NewRelicBrowser } from '@lib/newRelic/NewRelicBrowser';

export function dispatchNotinoEvent(
  args: Parameters<
    NonNullable<NonNullable<typeof window.NotinoAPI>['Events']>['publish']
  >[0]
) {
  if (window?.NotinoAPI?.Events) {
    window.NotinoAPI.Events.publish(args);
  } else {
    NewRelicBrowser.agent.noticeError('window.NotinoAPI.Events is not defined');
  }
}
